import { Cell, Grid } from 'bold-ui'
import { ClassificacaoRisco, TipoServico } from 'graphql/types.generated'
import React from 'react'

import { AtendimentoTag, AtendimentoTagProps } from './AtendimentoTag'

export interface AtendimentoTagsProps {
  tiposServico?: TipoServico[]
  classificacaoRisco?: ClassificacaoRisco
  horaAgendamento?: Instant
}

export function AtendimentoTags(props: AtendimentoTagsProps) {
  const { tiposServico, classificacaoRisco, horaAgendamento } = props
  const tags: AtendimentoTagProps[] = []

  horaAgendamento &&
    tags.push({
      horaAgendamento,
    })

  classificacaoRisco &&
    classificacaoRisco !== ClassificacaoRisco.NAO_CLASSIFICADO &&
    tags.push({
      classificacaoRisco,
    })

  tiposServico?.sort((a, b) => a.nome.localeCompare(b.nome))

  tiposServico
    ?.filter((ts) => ts.nome !== 'AGENDADO')
    .forEach((item) =>
      tags.push({
        tipoServico: item,
      })
    )

  return (
    <Grid gap={0.5} gapVertical={0.25} justifyContent='flex-start'>
      {tags?.map((item, index) => (
        <Cell key={index}>
          <AtendimentoTag
            key={index}
            classificacaoRisco={item.classificacaoRisco}
            horaAgendamento={item.horaAgendamento}
            tipoServico={item.tipoServico}
          />
        </Cell>
      ))}
    </Grid>
  )
}
